import { FacilitatorChatPanel } from '@/components/chat';
import { useEventContext } from '@/pages/events/useEventContext';
import { Skeleton } from '@startupquickstart/frontend';

export function EventChatTab() {
  const { event, isLoading } = useEventContext();

  if (isLoading) {
    return (
      <div className="flex-1 min-h-0">
        <Skeleton className="h-full rounded-xl" />
      </div>
    );
  }

  if (!event) {
    return (
      <div className="text-center py-12">
        <p className="text-muted-foreground">Event not found</p>
      </div>
    );
  }

  return (
    <div className="flex-1 min-h-0">
      <FacilitatorChatPanel eventId={event.id} />
    </div>
  );
}
